import React from "react";
import
{
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
// import Helper from "../../utility/helper";

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    cellContent: {
        width: '180px',
        flexBasis: '180px',
        padding: 8
    }
}));

const AllStarRegistrationAccordianCard = (props) =>
{
    const classess = useStyles();
    const { classes, item } = props;
    const RegistrationInfo = item.actualData;
    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none", padding:'8px 16px 16px'  }} >
                <CardContent className={classess.cardContent}>
                    <Box className={classes.rowContent}  style={{ justifyContent: 'left' }}>
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.addedForName}</span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.email}</span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Contact No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.contactNo}</span>
                                </Typography>
                            </Box>
                        </Box>
                        {RegistrationInfo.alternateContactName && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Alternate Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.alternateContactName}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.alternateContactNo && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Alternate Contact No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{RegistrationInfo.alternateContactNo}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.alternateContactEmail && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Alternate Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: "break-word" }}>
                                    <span>{RegistrationInfo.alternateContactEmail}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Accommodation Needed
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.isWheelCheck === true ? "Yes" : "No"}</span>
                                </Typography>
                            </Box>
                        </Box>
                        {RegistrationInfo.isWheelCheck === true && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Accommodation
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.isWheelCheck === false ? "" : RegistrationInfo.occommodation}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Hotel Needed
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.isHotelCheck === true ? "Yes" : "No"}</span>
                                </Typography>
                            </Box>
                        </Box>
                        {RegistrationInfo.isHotelCheck === false && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Location
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.isHotelCheck === true ? "" : RegistrationInfo.location}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {RegistrationInfo.ringSize && RegistrationInfo.ringSize !== 0 ? <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Ring Size
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.ringSize}</span>
                                </Typography>
                            </Box>
                        </Box> : null}
                        {RegistrationInfo.comments && <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Additional Comments
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{RegistrationInfo.comments}</span>
                                </Typography>
                            </Box>
                        </Box>}
                        {/* {RegistrationInfo.submittedDate !== "" ?
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Submitted Date
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{Helper.FormatDateTime(RegistrationInfo.submittedDate)}</span>
                                    </Typography>
                                </Box>
                            </Box>
                            : ""} */}
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default AllStarRegistrationAccordianCard;